"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.strategy = void 0;
const erc721_abi_1 = require("../../abi/erc721.abi");
const environment_1 = require("../../environment/environment");
const web3Factory_1 = require("../helpers/web3Factory");
const required_1 = require("../../helpers/required/required");
/** example
 [
    [
        {
            name: 'room-owner',
        }
    ]
 ]
 * @param web3Provider
 */
exports.strategy = (strategy) => __awaiter(void 0, void 0, void 0, function* () {
    const web3Provider = yield web3Factory_1.web3Factory(strategy.params.chainId);
    const { tokenId } = strategy;
    const contractAddress = environment_1.ContractAddresses[strategy.params.chainId];
    required_1.requiredDefined(contractAddress, 'this chainId does not have a spkz nft contract');
    required_1.requiredDefined(tokenId, 'this tokenId is not defined');
    let isAuthorized = false;
    let code;
    let message;
    if (strategy.addresses && strategy.addresses.length > 0) {
        const roomContract = new web3Provider.eth.Contract(erc721_abi_1.erc721ABI, contractAddress);
        const ownerOf = yield roomContract.methods.ownerOf(tokenId).call().catch(() => null);
        isAuthorized = strategy.addresses[0].toLowerCase() === ownerOf.toLowerCase();
        code = isAuthorized ? 0 /* SUCCESS */ : 2 /* NOTOWNER */;
        message = (strategy.addresses[0] && strategy.addresses[0] === ownerOf)
            ? `You are the owner of Room #${tokenId}`
            : `You are not the owner of Room #${tokenId}`;
    }
    return {
        isAuthorized,
        strategy: strategy,
        message: message,
        code
    };
});
//# sourceMappingURL=index.js.map